import { useCustomerPageContext } from "@contexts/customer"
import { getProducts } from "@domain/customer/list"
import Stack from "@mui/material/Stack"

import CurrentPlanButtons from "@pages/customer/infos/tabs/plan_billing/sub_components/buttons"
import CurrentPlan from "@pages/customer/infos/tabs/plan_billing/sub_components/current_plan"
import PaymentInformation from "@pages/customer/infos/tabs/plan_billing/sub_components/payment_information"
import Usage from "@pages/customer/infos/tabs/plan_billing/sub_components/usage"
import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router-dom"

export default function CustomerPlanPage() {
  const { currentCustomer } = useCustomerPageContext()
  const { id } = useParams()
  const customerId = currentCustomer?._id || id

  const { data: products } = useQuery({
    queryKey: ["special-offer", customerId],
    queryFn: async () => {
      if (!customerId) {
        return []
      }
      const { errorMessage, data } = await getProducts({
        customerId
      })
      if (!!errorMessage) {
        return []
      }
      return data
    },
    enabled: !!customerId
  })

  return (
    <Stack gap={3} py={2}>
      <Usage />
      <PaymentInformation />
      <CurrentPlan />
      <CurrentPlanButtons products={products} />
    </Stack>
  )
}
